import React, { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../link";
import Navbar from "../components/Navbar";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";

const Collage = () => {
  const [collages, setCollages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [modalData, setModalData] = useState({ collagename: "", area: "" });

  const API_URL = url + "/edusphere/collages";

  useEffect(() => {
    fetchCollages();
  }, []);

  const fetchCollages = () => {
    axios.get(API_URL).then((res) => setCollages(res.data));
  };

  const handleAdd = () => {
    setModalData({ collagename: "", area: "" });
    setEditId(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setModalData({ collagename: item.collagename, area: item.area });
    setEditId(item.cid);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this college?")) {
      axios.delete(`${API_URL}/${id}`).then(fetchCollages);
    }
  };

  const handleChange = (e) => {
    setModalData({ ...modalData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const data = { ...modalData };
    const endpoint = editId ? `${API_URL}/${editId}` : API_URL;
    const method = editId ? "put" : "post";

    axios({ method, url: endpoint, data }).then(() => {
      setShowModal(false);
      fetchCollages();
    });
  };

  return (
    <div className="container-fluid mt-4">
      <Navbar />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fw-bold">College List</h2>
        <button
          className="btn btn-primary rounded-circle p-3"
          onClick={handleAdd}
        >
          <FaPlus />
        </button>
      </div>

      {/* Cards Grid */}
      <div className="row">
        {collages.map((item) => (
          <div className="col-md-4 mb-4" key={item.cid}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="card-title fw-bold">{item.collagename}</h5>
                <p className="text-muted">📍 {item.area}</p>
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-sm btn-outline-warning me-2"
                    onClick={() => handleEdit(item)}
                  >
                    <FaEdit /> Edit
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(item.cid)}
                  >
                    <FaTrash /> Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}

        {collages.length === 0 && (
          <p className="text-center text-muted mt-5">No colleges found.</p>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg rounded-4">
              <div className="modal-header border-0">
                <h5 className="modal-title fw-bold">
                  {editId ? "Edit College" : "Add College"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">College Name</label>
                <input
                  className="form-control mb-3"
                  name="collagename"
                  placeholder="Enter college name"
                  value={modalData.collagename}
                  onChange={handleChange}
                />
                <label className="form-label">Area</label>
                <input
                  className="form-control mb-3"
                  name="area"
                  placeholder="Enter area"
                  value={modalData.area}
                  onChange={handleChange}
                />
              </div>
              <div className="modal-footer border-0">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Collage;
